module.exports = __webpack_public_path__ + "385ce3bd47412e6f8aed9ab2903957e4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-11.png
// module id = 3101
// module chunks = 0